import { useInfiniteQuery } from "react-query";
import { useTranslation } from "react-i18next";
import { App } from "antd";
import * as api from "apis/auditLog";

export const useAuditLogs = ({ payload = {} }, options = {}) => {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useInfiniteQuery(
    ["auditLogs/pagination", payload],
    async ({ pageParam = 1 }) => {
      let response;
      try {
        const {
          data: { data },
        } = await api.getAuditLog({ page: pageParam, ...payload });
        response = data;
      } catch (error) {
        throw new Error("Failed to load data from server!");
      }
      return response;
    },
    {
      getNextPageParam: (lastPage) => {
        if (!lastPage) {
          return undefined;
        }
        return lastPage.current_page < lastPage.last_page
          ? lastPage.current_page + 1
          : undefined;
      },
      keepPreviousData: true,
      onError: (error) =>
        message.error(t("error.failed_to_load_data_from_server")),
      ...options,
    }
  );
};
